import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth';
import { environment } from '../environments/environment';
// import { initializeApp } from 'firebase/app';
// Highlight JS
import { SplashScreenModule } from './_metronic/partials/layout/splash-screen/splash-screen.module';
// #fake-start#
import { ToastrModule } from 'ngx-toastr';
import { AppErrorHandler } from './_metronic/shared/crud-table/services/app-error-handler';
import { HttpErrorInterceptor } from './_metronic/shared/crud-table/services/http-error-interceptor.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DecimalPipe } from '@angular/common';
import { PrivacyForAllComponent } from './privacy-for-all/privacy-for-all.component';
import { ReferenceLinkForAllComponent } from './reference-link-for-all/reference-link-for-all.component';
import {NgxSpinnerModule} from "ngx-spinner";
import { ManagePackagesComponent } from './modules/manage-packages/manage-packages.component';
import { ManageRulesComponent } from './modules/manage-rules/manage-rules.component';
import {CRUDTableModule} from "./_metronic/shared/crud-table";
import { ChangeSeverityDialogComponent } from './modules/manage-rules/change-severity-dialog/change-severity-dialog.component';
import {NgxSelectModule} from "ngx-select-ex";
import { TicketsComponent } from './modules/tickets/tickets.component';
import { AddTicketComponent } from './modules/tickets/add-ticket/add-ticket.component';
import { TicketDetailsComponent } from './modules/tickets/ticket-details/ticket-details.component';
import { ChangeTicketStatusComponent } from './modules/tickets/change-ticket-status/change-ticket-status.component';
import { AddCommentComponent } from './modules/tickets/add-comment/add-comment.component';

// #fake-end#

// initializeApp(environment.firebase);

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve:any) => {
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

@NgModule({
  declarations: [AppComponent, PrivacyForAllComponent, ReferenceLinkForAllComponent,
    ManagePackagesComponent, ManageRulesComponent, ChangeSeverityDialogComponent, TicketsComponent, AddTicketComponent, TicketDetailsComponent, ChangeTicketStatusComponent, AddCommentComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
        }),
        SplashScreenModule,
        TranslateModule.forRoot(),
        HttpClientModule,
        NgSelectModule,
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        CRUDTableModule,
      NgxSelectModule,

      // ServiceWorkerModule.register('ngsw-worker.js', {
        //     enabled: environment.production,
        //     // Register the ServiceWorker as soon as the app is stable
        //     // or after 30 seconds (whichever comes first).
        //     registrationStrategy: 'registerWhenStable:30000'
        // })
    ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler,
    },
    DecimalPipe,

  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
